import Vuelidate from 'vuelidate'

export default ({ app, router, Vue }) => {
	Vue.use(Vuelidate)
}
